import { Screenshot } from "./screenshot.types";
import ScreenshotCard from "./ScreenshotCard";

import appMobileImg from '../../../assets/mobile/mesas-phone.png';
import menuOnlineMobileImg from '../../../assets/mobile/menu-online-mobile.png';
import menuOnlineDetailMobileImg from '../../../assets/mobile/menu-online-detail-mobile.png';
import cashierMobileImg from '../../../assets/mobile/caixa-phone.png';
import workplaceMobileImg from '../../../assets/mobile/workplace-mobile.png';
import workplaceTableImg from '../../../assets/mobile/workplace-tablet.png';
import workplaceMobile2Img from '../../../assets/mobile/cozinha-phone.png';
import workplaceExpandedMobileImg from '../../../assets/mobile/workplace-expanded-mobile.png';

import workplaceDesktopImg from '../../../assets/desktop/workplace-desktop.png';
import workplace2DesktopImg from '../../../assets/desktop/cozinha-desktop.png';
import workplaceExpandedDesktopImg from '../../../assets/desktop/workplace-expanded-desktop.png';
import homeImg from '../../../assets/desktop/mesas.png';
import dashboardDesktopImg from '../../../assets/desktop/dashboard.png';
import dashboard2DesktopImg from '../../../assets/desktop/dashboard-2.png';
import dashboard3DesktopImg from '../../../assets/desktop/dashboard-3.png';
import cashierDesktopImg from '../../../assets/desktop/caixa-desktop.png';

const screenshots: Screenshot[] = [
  {
    icon: '📊',
    img_urls: [dashboardDesktopImg, dashboard2DesktopImg, dashboard3DesktopImg],
    title: 'Dashboard Principal',
    description: 'Visão geral completa com métricas importantes, vendas do dia e alertas em tempo real.'
  },
  {
    icon: '🍽️',
    img_urls: [homeImg, appMobileImg],
    title: 'Gestão de Pedidos',
    description: 'Interface limpa para acompanhar todos os pedidos, desde a entrada até a entrega.'
  },
  {
    icon: '📦',
    img_urls: [menuOnlineMobileImg, menuOnlineDetailMobileImg],
    title: 'Menu Online',
    description: 'Clientes com acesso facilitado do Menu Online.'
  },
  {
    icon: '🖨️',
    img_urls: [workplaceDesktopImg, workplace2DesktopImg, workplaceExpandedDesktopImg, workplaceMobileImg, workplaceTableImg, workplaceMobile2Img, workplaceExpandedMobileImg],
    title: 'Fila de Pedido por setor',
    description: 'Sistema de fila do pedido por setor, trazendo organização e facilidade na verificação do pedido.'
  },
  {
    icon: '📈',
    img_urls: [cashierDesktopImg, dashboard3DesktopImg],
    title: 'Gestão de caixa',
    description: 'Acompanhe todas as formas de pagamento.'
  },
  {
    icon: '📱',
    img_urls: [appMobileImg, menuOnlineDetailMobileImg, cashierMobileImg, workplaceMobileImg, workplaceTableImg, workplaceMobile2Img],
    title: 'App Mobile',
    description: 'Acesse todas as funcionalidades do sistema direto do seu smartphone ou tablet.'
  },
];


const Screenshots: React.FC = () => (
  <section id="capturas" className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">Conheça o Sistema</h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Interface moderna e intuitiva desenvolvida para facilitar a gestão do seu restaurante
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {screenshots.map((screenshot, index) => (
          <ScreenshotCard key={index} screenshot={screenshot} index={index} />
        ))}
      </div>
    </div>
  </section>
);

export default Screenshots;